export const BASE_URL = process.env.NODE_ENV == "development" ? "http://localhost:8080/api/" : "https://elmon-testi-server.paas.datacenter.fi/api/"